import { Injectable } from '@angular/core';
import {
  DeviceType,
  NavigationDirection,
  NavigationPage,
} from '@interfaces/common.interface';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavController, Platform } from '@ionic/angular';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  protected readonly _scrolling$ = new BehaviorSubject<boolean>(false);

  constructor(
    private platform: Platform,
    private router: Router,
    private navCtrl: NavController,
  ) {}

  // goTo(page: NavigationPage): void {
  //   this.router.navigate([page]);
  // }

  public get scrolling$(): Observable<boolean> {
    return this._scrolling$.asObservable();
  }

  public setScrolling(value: boolean): void {
    this._scrolling$.next(value);
  }

  public getTargetDevice(): DeviceType {
    if (this.platform.is('electron')) {
      return 'native';
    } else {
      if (this.platform.is('capacitor')) {
        if (this.platform.is('tablet')) {
          return 'tablet';
        } else {
          return 'mobile';
        }
      } else {
        if (this.platform.is('mobileweb')) {
          const t = this.platform.is('mobile');
          if (this.platform.is('tablet')) {
            return 'web-tablet';
          } else {
            return 'web-mobile';
          }
        } else {
          return 'desktop';
        }
      }
    }
  }

  public getCurrentRoute() {
    const fullRoute = this.router.url.split('?')[0];
    const device = fullRoute.split('/')[1];
    if (device !== 'mobile' && device !== 'tablet') {
      return { device, route: fullRoute.substring(1) };
    } else {
      const route = fullRoute.split('/');
      route.splice(1, 1);
      return { device, route: route.join('/').substring(1) };
    }
  }

  public async goTo(
    page: NavigationPage,
    direction: NavigationDirection = 'forward',
    animated: boolean = true,
    params: any = null,
    navigationOptions?: NavigationOptions,
  ): Promise<any> {
    const device: DeviceType = this.getTargetDevice();
    if (device) {
      let uri = `/${page}`;
      // switch (device) {
      //   case 'mobile':
      //   case 'web-mobile':
      //     uri = `/mobile/${page}`;
      //     break;
      //   case 'tablet':
      //   case 'web-tablet':
      //     //TODO: Change this to /tablet/ when tablet ux is ready
      //     uri = `/mobile/${page}`;
      //     break;
      //   default:
      //     uri = `/${page}`;
      // }
      if (params) {
        uri = `${uri}/${params}`;
      }
      switch (direction) {
        case 'forward':
          this.navCtrl
            .navigateForward(uri, { animated, ...navigationOptions })
            .then(() => true);
          break;
        case 'backward':
          await this.navCtrl
            .navigateBack(uri, { animated, ...navigationOptions })
            .then(() => true);
          break;
        case 'root':
        default:
          await this.navCtrl
            .navigateRoot(uri, { animated, ...navigationOptions })
            .then(() => true);
      }
    } else {
      console.error('Device Type not recognized');
    }
  }

  public goBack() {
    this.navCtrl.back();
  }
}
